const requestConfig = require('../../bin/config');
const apiDomain = process.env.VUE_ENV === 'server' ? requestConfig.apiDomain : '';

export const menuListHome = `${apiDomain}/m/app/global/2/m_new.json?plat=m`; // 首页二级导航
export const menuListMatch = `${apiDomain}/m/app/global/2/m.json?menu=match&plat=m`; // 比赛二级导航
export const menuListStats = `${apiDomain}/m/app/global/2/m.json?menu=stats&plat=m`; // stats二级导航
export const menuListVideo = `${apiDomain}/m/app/global/2/m_new.json?menu=video&plat=m`; // video二级导航



// WEBPACK FOOTER //
// ./src/api/urlConfig.js